import React from 'react';
import { Resource } from '../../../types';
import { useTranslation } from '../../../contexts/TranslationContext';

interface InteractiveDiagramConfigurationFormProps {
  resource: Resource;
  onUpdate: (updates: Partial<Resource>) => void;
}

export const InteractiveDiagramConfigurationForm: React.FC<InteractiveDiagramConfigurationFormProps> = ({
  resource,
  onUpdate
}) => {
  const { t } = useTranslation();
  
  const updateResource = (field: string, value: any) => {
    onUpdate({ [field]: value });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{t('resourceConfig.diagramTitle')}</label>
        <input
          type="text"
          value={resource.title || t('resourceConfig.interactiveDiagram')}
          onChange={(e) => updateResource('title', e.target.value)}
          className="input-field"
          placeholder={t('resourceConfig.enterDiagramTitle')}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{t('resourceConfig.numberOfStages')}</label>
        <input
          type="number"
          value={resource.stages?.length || 3}
          onChange={(e) => {
            const stageCount = parseInt(e.target.value);
            const newStages = Array.from({ length: stageCount }, (_, i) => `stage${i + 1}`);
            const newStageData: any = {};
            newStages.forEach((stage, index) => {
              newStageData[stage] = {
                title: `${t('resourceConfig.stage')} ${index + 1}`,
                description: `${t('resourceConfig.stage')} ${index + 1} ${t('resourceConfig.stageDescription')}`,
                details: `${t('resourceConfig.detailedInformationAboutStage')} ${index + 1}`,
                icon: ['🌱', '🌿', '🌳', '🌸', '🍃'][index] || '📋'
              };
            });
            onUpdate({ 
              stages: newStages,
              stage_data: newStageData
            });
          }}
          className="input-field"
          min="1"
          max="10"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Interactive</label>
        <input
          type="checkbox"
          checked={resource.interactive !== false}
          onChange={(e) => updateResource('interactive', e.target.checked)}
          className="rounded border-gray-300"
        />
        <span className="ml-2 text-sm text-gray-600">Allow user interaction</span>
      </div>
    </div>
  );
};
